import { combineReducers } from 'redux';

import user from './user';
import category from './category';
import promo from './promo';
import post from './post';
import unapproved_promo from './unapproved_promo';
import layout from './layout';
import mall from './mall';
import store from './store';
import outlet from './outlet';
import ad from './ad';
import offer_option from './offer_option';
import uploadScrappedPromo from './uploadScrappedPromo';
import tag from './tag';
import masterName from './masterName';
import { default as page } from './pageReducer';

export default combineReducers({
  user,
  category,
  promo,
  unapproved_promo,
  uploadScrappedPromo,
  mall,
  store,
  outlet,
  layout,
  ad,
  offer_option,
  page,
  post,
  tag,
  masterName,
});
